function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.7945 13.2316C15.7945 12.4952 15.1976 11.8982 14.4612 11.8982H1.33297C0.596557 11.8982 -0.000366211 12.4952 -0.000366211 13.2316C-0.000366211 13.968 0.596557 14.5649 1.33297 14.5649H14.4612C15.1976 14.5649 15.7945 13.968 15.7945 13.2316ZM15.7945 7.28264C15.7945 6.54623 15.1976 5.94931 14.4612 5.94931H1.33297C0.596557 5.94931 -0.000366211 6.54623 -0.000366211 7.28264C-0.000366211 8.01905 0.596557 8.61598 1.33297 8.61598H14.4612C15.1976 8.61598 15.7945 8.01905 15.7945 7.28264ZM14.4612 2.66746H1.33297C0.596557 2.66746 -0.000366211 2.07054 -0.000366211 1.33413C-0.000366211 0.597717 0.596557 0.000793457 1.33297 0.000793457H14.4612C15.1976 0.000793457 15.7945 0.597717 15.7945 1.33413C15.7945 2.07054 15.1976 2.66746 14.4612 2.66746Z",
  fill: "#495A95"
});

var SvgIconHamburger = function SvgIconHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_hamburger.f87004ef.svg";
export { ForwardRef as ReactComponent };